module.exports = __webpack_public_path__ + "img/kjjh_gallery8.bbce7cd5.jpg";